// lib/funnels/functions/v1/metrics/captureEvent.js
import * as Sentry from '@sentry/browser'
import { getFunnelFromUrl } from '../default/getFunnelFromUrl'
import { getTrackingIds } from './getTrackingIds'

export const SENTRY_METRIC_EVENTS = new Set([
  'form-loaded',
  'form-clicked',
  'form-submitted',
  'form-sent-to-chat',
  'form-sent-to-downsell',
  'form-submit-slow',
  'offer-clicked',
  'no-redirect-url-returned-by-be',
  'my-results-loaded',
  'my-results-submitted',
  'my-results-sent-to-chat',
  'my-results-sent-to-downsell',
  'chat-session-not-found',
])

/**
 * Event names that carry a configured value, e.g. `api-call-above-5000`
 */
export const SENTRY_METRIC_EVENT_PATTERNS = [/^api-call-above-\d+$/]

/**
 * @param {string} name - lowercased event name
 * @returns {boolean}
 */
const isAllowedEvent = (name) =>
  SENTRY_METRIC_EVENTS.has(name) ||
  SENTRY_METRIC_EVENT_PATTERNS.some((pattern) => pattern.test(name))

/**
 * Pathname plus the `flow` query param when present (e.g. `/foo/?flow=bar`).
 * Every other query param is dropped.
 * @returns {string}
 */
export const getMetricPath = () => {
  const { pathname, search } = window.location
  const flow = new URLSearchParams(search).get('flow')

  return flow ? `${pathname}?flow=${encodeURIComponent(flow)}` : pathname
}

/**
 * Captures metric event
 *
 * @param {string} event - event name
 * @param {Record<string, string|number|boolean>} [attributes] - extra Sentry metric attributes
 */
export function captureEvent(event, attributes = {}) {
  const name = event.toLowerCase()
  if (!isAllowedEvent(name)) {
    console.warn(
      `Sentry metric event "${name}" is not in the allowed list. Skipping.`,
    )
    return
  }

  if (typeof Sentry.logger?.info !== 'function') return

  try {
    Sentry.logger.info(name, {
      event: name,
      funnel: getFunnelFromUrl(),
      path: getMetricPath(),
      ...getTrackingIds(),
      ...attributes,
    })
  } catch (error) {
    console.warn('Sentry log failed', error)
  }
}
